import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapMutations, mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'ViewISFMAccess',
  data: function data() {
    return {
      accessItemsUI: [],
      favType: 'accessMgmt'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })),
  mounted: function mounted() {
    this.getAccessObjects();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    getAccessObjects: function getAccessObjects() {
      var _this = this;

      return ApiService.isFmAccessFetchByUserId(this.sessionUserId).then(function (data) {
        _this.accessItemsUI = data;

        _this.checkAccessObjects();
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('IS.FM.AccessMgmt.errorFetchingAccess'), 'error');
        }
      }).finally(function () {
        _this.$store.state.app.loading = false;
      });
    },
    keyTwinTitle: function keyTwinTitle(item) {
      return "".concat(get(item, 'dtwinData.title'), " (").concat(get(item, 'parentData.title'), ")");
    },
    checkAccessObjects: function checkAccessObjects() {
      var _this2 = this;

      this.accessItemsUI.forEach(function (element) {
        try {
          if (!element.accessObjectData.data.isFm.doorId) {
            _this2.$snack("\n              ".concat(_this2.$i18n_t('IS.FM.AccessMgmt.errorDoorConf'), "\n              ").concat(element.accessObjectData.title, "\n            "), 'error');
          }
        } catch (e) {
          _this2.$snack(e, 'error');
        }
      });
    }
  })
};